
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { GradientPoint } from "@/types/colors";
import { generateGradientStyle } from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/helpers";

@Component
export default class AreaPreview extends Vue {
  @Prop()
  red!: number;

  @Prop()
  green!: number;

  @Prop()
  blue!: number;

  @Prop()
  alpha!: number;

  @Prop()
  points!: GradientPoint[];

  @Prop()
  gradientDegree!: number;

  @Prop()
  gradientType!: string;

  get style() {
    const style = generateGradientStyle(
      this.points,
      this.gradientType,
      this.gradientDegree
    );

    return { background: style };
  }
}
